import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Container, MainContent} from "../styles";
import SidebarCardHeader from "../../SidebarCardHeader";
import {SearchInputCustom} from "../../../ui/SearchInputCustom";
import {ResultSearchContentSidebarCard} from "../../Sidebar/styles";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar/SidebarSearch";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {dataMapDirectionFilters} from "../dataMapFilters";
import {SidebarCardSearchClustersItem} from "./SidebarCardSearchClustersItem";
import {IClusterDataFromServer} from "../../../pages/Dashboard/Dashboard.type";

interface IProps {
  onCloseCard: () => void;
  typeRadar: ITypeRadar;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: string,
    typeRadar?: ITypeRadar
  ) => void;
  searchDatasidebarInfo?: IDataForSearchSidebar;
  allClusters?: IClusterDataFromServer[];
}

export const SidebarCardSearchClusters: FC<IProps> = ({
  onCloseCard,
  typeRadar,
  openSidebarWithTab,
  searchDatasidebarInfo,
  allClusters,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");
  // const [resultSearchFind, setResultSearchFind] = useState(
  //   {} as IDataForSearchSidebar
  // );
  const [sortOption, setSortOption] = useState<string>("");
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);

  const resultSearchFind = useMemo(() => {
    const resultsFindClusters =
      inputSearchValue === ""
        ? searchDatasidebarInfo?.clusters
        : searchDatasidebarInfo?.clusters?.filter((item) =>
            item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
          );
    return {
      ...searchDatasidebarInfo,
      clusters: resultsFindClusters ?? [],
    } as IDataForSearchSidebar;
  }, [inputSearchValue, searchDatasidebarInfo]);

  // Мемоизация функций
  const handleSort = useCallback((option: string) => {
    setSortOption(option);
    // console.log(option);
  }, []);

  const handleTypeSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputSearchValue(event.target.value);
    },
    []
  );

  const handleSortTitle = useCallback(() => {
    return `ТЕХНОЛОГИИ `;
  }, []);

  const memoizedClusters = useMemo(
    () => resultSearchFind.clusters || [],
    [resultSearchFind.clusters]
  );

  return (
    <Container>
      <SidebarCardHeader
        previewTitle="Кластеры"
        title="ПОИСК ПО КЛАСТЕРАМ"
        colorTitle="#53C6F5"
        onClose={onCloseCard}
        color="#858E97"
      />
      <MainContent>
        <SearchInputCustom
          searchInputRef={searchInputRef}
          inputSearchValue={inputSearchValue}
          handleTypeSearch={handleTypeSearch}
          setInputSearchValue={setInputSearchValue}
        />

        {/* {inputSearchValue.length > 0 && ( */}
        <div
          style={{
            color: "#fff",
            padding: "5px 0",
            zIndex: 1,
          }}
        >
          {resultSearchFind.clusters && resultSearchFind.clusters.length > 0 ? (
            <div>
              <BlockFIlteredMap
                handleSortTitle={handleSortTitle}
                handleSort={handleSort}
                sortOption={sortOption}
                dataMapFiltered={dataMapDirectionFilters}
                setIsShowTitleParams={setIsShowTitleParams}
                isShowTitleParams={isShowTitleParams}
                isHideSortBlock
              />
              <p
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "16px",
                  margin: "20px 0 10px",
                }}
              >
                Результаты:
              </p>
              {typeRadar === "map" && (
                <ResultSearchContentSidebarCard>
                  <div>
                    {memoizedClusters.map((cluster) => {
                      return (
                        <SidebarCardSearchClustersItem
                          key={cluster.id}
                          id={cluster.id}
                          directionId={cluster.direction_id}
                          name={cluster.name}
                          searchDatasidebarInfo={searchDatasidebarInfo}
                          allClusters={allClusters}
                          isShowTitleParams={isShowTitleParams}
                          typeRadar={typeRadar}
                          openSidebarWithTab={openSidebarWithTab}
                        />
                      );
                    })}
                  </div>
                </ResultSearchContentSidebarCard>
              )}
            </div>
          ) : (
            <div
              style={{
                padding: "5px 10px",
                borderBottom: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              Ничего не найдено
            </div>
          )}
        </div>
        {/* )} */}
      </MainContent>
    </Container>
  );
};
